export default __webpack_public_path__ + "static/media/bsp-img.60816b15.jpg";